export const videoCardStyles = {
  sm: { header: 'text-md', text: 'text-sm', icon: 24 },
  md: { header: 'text-xl', text: 'text-md', icon: 32 },
} as const;

export const UNTITLED_VIDEO_NAME = 'Untitled';
